module.exports = __webpack_public_path__ + "img/fcz.41a1f59a.jpg";